//
//
//
//
//

import _ from 'underscore'
import Vue from 'vue'
import Provide from 'element-address-provide'
import Cascader from 'element-ui/lib/cascader'
// import DIC from '@/index/dictonary'

export default {
  props: {
    province: {
      default: undefined
    },
    city: {
      default: undefined
    },
    area: {
      default: undefined
    }
  },
  data: function () {
    return {
      // value: [undefined,undefined,undefined]
      value: []
    }
  },
  components: {
    Provide,
    Cascader
  },
  watch: {
    province: {
      handler (val) {
        if (this.value[0] !== val) {
          Vue.set(this.value,0,val)
        }
      },
      immediate: true
    },
    city: {
      handler (val) {
        if (this.value[1] !== val) {
          Vue.set(this.value,1,val)
        }
      },
      immediate: true
    },
    area: {
      handler (val) {
        if (this.value[2] !== val) {
          Vue.set(this.value,2,val)
        }
      },
      immediate: true
    },
    value: {
      handler (val) {
        if (val) {
          if (this.value[0] && this.value[0] !== this.province)
            this.$emit('update:province', this.value[0])
          if (this.value[1] && this.value[1] !== this.city)
            this.$emit('update:city', this.value[1])
          if (this.value[2] && this.value[2] !== this.area)
            this.$emit('update:area', this.value[2])
        }
      },
      deep:true
    }
  },
  mounted () {

  },
  methods: {

  }
}
